export const SORTABLE_FIELDS = [
  "serviceCenter",
  "createdAt",
  "salesOrderNumber",
  "deliveryDate",
  "itemNumber",
  "status",
  "quantity",
] as const;

export const SHIPMENT_STATUS_CONFIG = {
  IN_TRANSIT:    { bg: "#E6F7FF", text: "#0050B3" },
  RECEIVED:      { bg: "#F6FFED", text: "#237804" },
  LOST:          { bg: "#FFF7E6", text: "#AD4E00" },
  DAMAGED:       { bg: "#FFF1F0", text: "#A8071A" },
  READY_TO_SHIP: { bg: "#E6F7FF", text: "#0050B3" },
  SHIPPED:       { bg: "#F6FFED", text: "#237804" },
  PARTIALLY_SHIPPED: { bg: "#FFF7E6", text: "#AD4E00" },
  DEFAULT:       { bg: "#F0F0F0", text: "#595959" },
} as const;


export const SEARCHABLE_FIELDS = [
  { label: "Service Center", value: "serviceCenter" },
  { label: "Sales Order", value: "salesOrderNumber" },
  { label: "Spare Part", value: "itemNumber" },
];

export const REGISTER_STATUS_CONFIG = {
  IN_USE: { color: "success" },
  UNUSED: { color: "blue" },
} as const;

export const SALES_ORDER_STATUS = {
  Pending: { color: "blue" },
  Shipped: { color: "success" },
  UnderProcess: { color: "warning" },
  Done: { color: "success" },
} as const;
